'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".Container-module_container__P04Z6{box-sizing:border-box;margin:0 auto;padding:0 .25rem}";
var styles = {"container":"Container-module_container__P04Z6"};
styleInject["default"](css_248z, 'dc04cf51-9988-4696-aed1-7df08105a47f');

exports["default"] = styles;
